import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import moment from 'moment';
import Loader from '../../../components/base/Loader/Loader';
import { Button, Icons } from '../../../components/base/BootstrapComponents';
import {
  Dialog, DialogContent,
} from '../../../components/base/Dialog/Dialog';
import { hideHistoryPopup, loadHistoryList, hostCommandCancel } from '../actions';
import { getPaginationOpts, responseLogWithNotification } from '../../../utils/utils';
import { getParkingMetersData } from '../reducer';
import {
  dateFormatter, dateTimeFormatter, timeHMFormatter,
} from '../../../utils/formatters';
import Pagination from '../../../components/base/Pagination/Pagination';
import notificationDecorator from '../../Notifications/notificationDecorator';
import { HOST_COMMAND_STATUS } from '../constants';
import { showGlobalConfirm } from '../../System/actions';
import { OperationStatusFormatter } from './ParkingFormatters';

export default function MobileParkingMeterHistoryPopup() {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();
  const {
    currentParkingMeter = null,
    loadingHostCommandHistory,
    hostCommandHistory,
    loadingHostCommandCancel,
    hostCommandHistoryMeta,
  } = useSelector(getParkingMetersData);

  const handleClose = () => {
    dispatch(hideHistoryPopup());
  };
  const handleLoadingHostList = opts => {
    if (!currentParkingMeter || !currentParkingMeter.id) {
      return null;
    }
    const paginationOpts = getPaginationOpts(hostCommandHistoryMeta, opts);
    dispatch(loadHistoryList({ host_id: currentParkingMeter.id, ...paginationOpts })).catch(responseLogWithNotification);
  };
  useEffect(() => { handleLoadingHostList({ page: 1 }); }, []);
  if (!currentParkingMeter || !currentParkingMeter.id) {
    return null;
  }

  const handleHostCommandCancel = id => {
    if (!id) {
      return null;
    }
    dispatch(showGlobalConfirm({
      confirmTitle: 'Отмена операции',
      confirmMessage: 'Вы уверены что хотите отменить операцию?',
    })).then(() => {
      dispatch(hostCommandCancel(id)).then(() => {
        notificationDecorator({
          title: 'Отмена операции',
          message: formatMessage({ id: 'success' }),
        });
      })
        .then(() => {
          handleLoadingHostList();
        })
        .catch(response => {
          responseLogWithNotification(response, 'Отмена операции');
        });
    });
  };

  const rowClassFormatter = item => {
    if (item.status === HOST_COMMAND_STATUS.CANCELED) {
      return 'canceled';
    }
    return '';
  };

  const scrollToTop = event => {
    const element = document.getElementById('parking-meter-scroll-block');
    element.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <Dialog
      onClose={handleClose}
      open
      className="parking-meter-history-popup"
      size="xl"
    >
      <DialogContent id="parking-meter-scroll-block">
        <Loader global loading={loadingHostCommandHistory || loadingHostCommandCancel} />

        <div className="pmh-header-bar">
          <Icons width={24} height={24} customIcon icon="arrow-back-ios" className="pmh-header-icon" onClick={handleClose} />
          {currentParkingMeter.host}
        </div>
        <div className="pmh-header-row">{`История команд паркомата ${currentParkingMeter.host}`}</div>

        <div className="pmh-list">
          {hostCommandHistory.map((item, key) => (
            <div key={key} className="pmh-item">
              <div className="pmh-status-date">
                <OperationStatusFormatter status={item.status} />
                <div className="pmh-executed-date">{item && item.executed_at ? moment(item.executed_at).format('HH:mm DD.MM.YY') : null}</div>
              </div>
              <div className="pmh-item-name pmh-item-border">{item.command_template.name}</div>
              <div className="pmh-item-date">
                <div className="pmh-item-date-label">Время и дата создания команды</div>
                <div className="pmh-item-date-value">
                  {timeHMFormatter(item.created_at)}<br />
                  {dateFormatter(item.created_at)}
                </div>
              </div>
              <div className={classNames('pmh-item-date', { 'pmh-item-border': HOST_COMMAND_STATUS.WAITING === item.status })}>
                <div className="pmh-item-date-label">Выполнить не позже</div>
                <div className="pmh-item-date-value">
                  {timeHMFormatter(item.expiration_at)}<br />
                  {dateFormatter(item.expiration_at)}
                </div>
              </div>
              {HOST_COMMAND_STATUS.WAITING === item.status
                ? (
                  <div className="pmh-item-button">
                    <Button onClick={() => { handleHostCommandCancel(item.id); }}>Отменить</Button>
                  </div>
                )
                : null}
            </div>
          ))}
        </div>
        <div className="going-top-wrapper">
          <div className="going-top" onClick={scrollToTop}>
            <Icons width={24} height={24} customIcon icon="arrow-upward" className="going-top-icons" />
          </div>
        </div>
        <Pagination meta={hostCommandHistoryMeta} list={hostCommandHistory} handleChangeMeta={handleLoadingHostList} />
      </DialogContent>
    </Dialog>
  );
}
